// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"788":"557fa052","8406":"aab086cd","9469":"3bf978d8"}[chunkId] + ".chunk.css";
};